<button id="genericListIconButton-button-{{ testingId | camelCase }}" mat-icon-button color="{{ buttonColor }}" (click)="handleClick($event)" [disabled]="disabled">
  <mat-icon>{{ icon }}</mat-icon>
</button>
